// extracted by mini-css-extract-plugin
export default {"value":"MemberItemValue_value__2zQ39"};